import { Target } from './Target';

export enum ChatMessageCurrentState {
  PENDING = 'Pending',
  SENT = 'Sent',
  FAILED = 'Failed',
}

export type Notification = {
  id: string;
  type: string;
  fromMemberId: string;
  fromMemberPicUrl: string;
  fromMemberHasDefaultPic?: boolean;
  fromMemberDisplayName?: string;
  toMemberId: string;
  title: string;
  content: string;
  statusFromMember: string;
  statusToMember: string;
  reason: string;
  priority: number;
  dateCreated: string;
  dateUpdated: string;
  target?: Target;
  category: number;
  currentState: ChatMessageCurrentState;
};
